import React, {} from "react";
import "./menu.css";
// Components
import ButtonBack from "../../common/buttonBack";
import ButtonEdit from "../../common/buttonEdit";
import ButtonDelete from "../../common/buttonDelete";

const MaintenanceDetailMenu = ({ 
  primaryValue,
  primaryName,
  config, 
  onDelete,
  itemNameSingular,
  itemIsMale,
  page,
}) => {
  const nextChildren = !!config.nextChildren ? config.nextChildren : [];

  return (
      <div id="maintenance-detail-menu">
        <ButtonBack config={config.buttonBack} />
        <ButtonEdit primaryValue={primaryValue} primaryName={primaryName} config={{...config.buttonEdit, marginLeft: "5px" }} page={page} itemNameSingular={itemNameSingular} onEditAddStringAtEndOfPath={config.onEditAddStringAtEndOfPath} />
        <ButtonDelete primaryValue={primaryValue} primaryName={primaryName} config={{...config.buttonDelete, marginLeft: "5px" }} itemNameSingular={itemNameSingular} itemIsMale={itemIsMale} onDelete={onDelete} />
        {nextChildren}
      </div>
  );
};

export default MaintenanceDetailMenu;
